import { render, staticRenderFns } from "./VerifyLogin.vue?vue&type=template&id=a671f6b4&scoped=true"
import script from "./VerifyLogin.vue?vue&type=script&lang=js"
export * from "./VerifyLogin.vue?vue&type=script&lang=js"
import style0 from "./VerifyLogin.vue?vue&type=style&index=0&id=a671f6b4&prod&lang=scss&scoped=true"
import style1 from "./VerifyLogin.vue?vue&type=style&index=1&id=a671f6b4&prod&lang=scss&rel=text%2Fcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a671f6b4",
  null
  
)

export default component.exports